import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'job-schedule',
  template: `
    <div>
      <div [e11SummernoteView]="schedule!"></div>
    </div>
  `,
})
export class JobScheduleComponent {
  @Input() schedule?: string

  constructor() {}
}
